import styled from 'styled-components';
import ChoiceSectionHeaderV2 from '@gcc/pip-components/dist/ChoiceSectionHeader/v2';
import { ViewAll } from '@gcc/pip-components/dist/collapsibles';

export const Option = styled.div.attrs({ className: 'option-component' })`
    background-color: #fff;
    width: 69%;
    padding: 5px 0px 5px 10px;
    margin: 0 10px;

    @media all and (max-width: 768px){
     width: 100%;
  }
`;

// match the standard ChoiceSectionHeader margin
// (since this template's header is inline)
export const HeaderRow = styled.div`
  margin-bottom: 10px;
`;

// inline so ViewAllRight is on same line
// (each `&` just increases specificity/priority of this rule)
export const InlineChoiceSectionHeader = styled(ChoiceSectionHeaderV2)`
  && {
    display: inline;
  }
`;

// self-explanatory
export const ViewAllRight = styled(ViewAll)`
  float: right;
  padding-right:50px
`;
